import { LocalStorageSaveForLaterItem } from '../types';

export const SAVE_FOR_LATER_ITEMS_KEY = 'save_for_later_items';

export const saveItemsToLocalStorage = (
  items: LocalStorageSaveForLaterItem[]
) => {
  try {
    const stringifiedItems = JSON.stringify(items);
    localStorage.setItem(SAVE_FOR_LATER_ITEMS_KEY, stringifiedItems);
    return true;
  } catch (error) {
    console.error('Error saving items to local storage:', error);
    return false;
  }
};
